import { render, staticRenderFns } from "./uploadPopUp.vue?vue&type=template&id=1b0725d6&scoped=true"
import script from "./uploadPopUp.vue?vue&type=script&lang=js"
export * from "./uploadPopUp.vue?vue&type=script&lang=js"
import style0 from "./uploadPopUp.vue?vue&type=style&index=0&id=1b0725d6&prod&lang=scss&scoped=true"
import style1 from "./uploadPopUp.vue?vue&type=style&index=1&id=1b0725d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0725d6",
  null
  
)

export default component.exports